/**
 * Yaksha Rituals — Native Shopify Theme JavaScript
 */
document.addEventListener('DOMContentLoaded', () => {
  initStickyNavbar();
  initCartDrawer();
  initAccordions();
  initVariantTabs();
  initAjaxCart();
  initCardVariantHover();
});

/* Cart Drawer Controller */
function initCartDrawer() {
  const triggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');
  const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');

  if (!drawer || !overlay) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCartAndUpdateDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  triggers.forEach(trigger => trigger.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));

  overlay.addEventListener('click', closeDrawer);
  closeBtns.forEach(btn => btn.addEventListener('click', closeDrawer));

  window.YakshaTheme = window.YakshaTheme || {};
  window.YakshaTheme.openCartDrawer = openDrawer;
  window.YakshaTheme.closeCartDrawer = closeDrawer;
}

/* AJAX Cart Updater */
function fetchCartAndUpdateDrawer() {
  const container = document.querySelector('[data-cart-drawer-items]');
  const totalEl = document.querySelector('[data-cart-drawer-total]');
  const countPills = document.querySelectorAll('[data-cart-count]');
  if (!container) return;

  const assets = window.YakshaAssets || {};
  const currencySymbol = assets.currency || '₹';

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Update count pills
      countPills.forEach(el => el.textContent = cart.item_count);

      const drawerFooter = document.querySelector('[data-cart-drawer-footer]');
      if (cart.item_count === 0) {
        if (drawerFooter) drawerFooter.style.display = 'none';
        container.innerHTML = `
          <div style="text-align: center; padding: 4rem 1rem;">
            <p style="font-family: var(--font-editorial, serif); font-style: italic; font-size: 1.25rem; color: #1F1E1C; margin-bottom: 1.5rem;">Your sacred ritual bag is empty.</p>
            <a href="/collections/all" class="btn-ritual" style="display: inline-block; padding: 12px 28px; font-size: 11px; text-decoration: none;">Explore Aromatics</a>
          </div>
        `;
        if (totalEl) totalEl.textContent = `${currencySymbol}0.00`;
        return;
      } else {
        if (drawerFooter) drawerFooter.style.display = 'block';
      }

      const impactAmount = ((cart.total_price * 0.01) / 100).toFixed(1);

      let html = `
        <div style="background-color: #5C0E20; color: #FAF8F5; padding: 10px 1.25rem; font-family: var(--font-sans, sans-serif); font-size: 11px; display: flex; justify-content: space-between; align-items: center; letter-spacing: 0.12em; text-transform: uppercase; margin: -1.5rem -2rem 1.5rem -2rem;">
          <span>🌿 1% to Sacred Groves</span>
          <span style="color: #C5A059; font-weight: 500;">${currencySymbol}${impactAmount} Pledged</span>
        </div>
        <div style="display: flex; flex-direction: column; gap: 1.25rem;">
      `;

      cart.items.forEach(item => {
        const linePrice = (item.final_line_price / 100).toFixed(2);
        
        // Smart fallback packshot if item.image is empty or broken
        let itemImg = item.image;
        if (!itemImg || itemImg.trim() === '') {
          const title = (item.product_title || '').toLowerCase();
          if (title.indexOf('sandalwood') !== -1 && assets.sandalwood) itemImg = assets.sandalwood;
          else if ((title.indexOf('vedic') !== -1 || title.indexOf('flame') !== -1) && assets.vedic_flame) itemImg = assets.vedic_flame;
          else if ((title.indexOf('maharani') !== -1 || title.indexOf('mist') !== -1) && assets.maharani_mist) itemImg = assets.maharani_mist;
          else if (title.indexOf('kasturi') !== -1 && assets.kasturi) itemImg = assets.kasturi;
          else if (title.indexOf('mogra') !== -1 && assets.mogra) itemImg = assets.mogra;
          else itemImg = assets.crest || '';
        }

        html += `
          <div style="display: flex; gap: 1rem; padding-bottom: 1.25rem; border-bottom: 1px solid rgba(197, 160, 89, 0.3); align-items: flex-start;">
            <div style="width: 72px; height: 72px; flex-shrink: 0; background-color: #FAF8F5; border: 1px solid rgba(197, 160, 89, 0.3); overflow: hidden; display: flex; align-items: center; justify-content: center;">
              <img src="${itemImg}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.src='${assets.crest || ''}'; this.style.padding='10px';">
            </div>
            
            <div style="flex-grow: 1; min-width: 0;">
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 0.5rem;">
                <div>
                  <h4 style="font-family: var(--font-serif, 'Marcellus', serif); font-size: 15px; margin: 0 0 3px 0; color: #1F1E1C; font-weight: 400; line-height: 1.3;">${item.product_title || ''}</h4>
                  ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-family: var(--font-sans, 'Tenor Sans', sans-serif); font-size: 10px; letter-spacing: 0.15em; text-transform: uppercase; color: #5C0E20; margin: 0 0 8px 0;">${item.variant_title}</p>` : ''}
                </div>
                
                <!-- Dedicated Item Remove Button -->
                <button
                  type="button"
                  data-cart-remove-key="${item.key}"
                  style="background: none; border: none; padding: 4px; cursor: pointer; color: rgba(31, 30, 28, 0.45); display: flex; align-items: center; gap: 3px; font-family: var(--font-sans, sans-serif); font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase; transition: color 0.2s ease;"
                  onmouseover="this.style.color='#5C0E20'"
                  onmouseout="this.style.color='rgba(31, 30, 28, 0.45)'"
                  title="Remove from cart"
                  aria-label="Remove ${item.product_title}"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  <span>Remove</span>
                </button>
              </div>

              <!-- Quantity Stepper & Price Row -->
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 6px;">
                <div style="display: inline-flex; align-items: center; border: 1px solid rgba(197, 160, 89, 0.4); background-color: #FAF8F5;">
                  <button
                    type="button"
                    data-cart-qty-change="${item.key}"
                    data-new-qty="${item.quantity - 1}"
                    style="padding: 2px 9px; background: none; border: none; cursor: pointer; font-size: 14px; color: #1F1E1C; line-height: 1;"
                    aria-label="Decrease quantity"
                  >&minus;</button>
                  <span style="padding: 2px 8px; font-family: var(--font-body, 'Jost', sans-serif); font-size: 12px; font-weight: 500; min-width: 22px; text-align: center; color: #1F1E1C;">
                    ${item.quantity}
                  </span>
                  <button
                    type="button"
                    data-cart-qty-change="${item.key}"
                    data-new-qty="${item.quantity + 1}"
                    style="padding: 2px 9px; background: none; border: none; cursor: pointer; font-size: 14px; color: #1F1E1C; line-height: 1;"
                    aria-label="Increase quantity"
                  >&plus;</button>
                </div>
                
                <span style="font-family: var(--font-body, 'Jost', sans-serif); font-weight: 500; font-size: 15px; color: #1F1E1C;">
                  ${currencySymbol}${linePrice}
                </span>
              </div>
            </div>
          </div>
        `;
      });
      html += '</div>';
      container.innerHTML = html;

      if (totalEl) {
        totalEl.textContent = `${currencySymbol}` + (cart.total_price / 100).toFixed(2);
      }

      // Attach Remove & Quantity Stepper Event Handlers
      container.querySelectorAll('[data-cart-remove-key]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const key = btn.getAttribute('data-cart-remove-key');
          updateCartItemQuantity(key, 0);
        });
      });

      container.querySelectorAll('[data-cart-qty-change]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const key = btn.getAttribute('data-cart-qty-change');
          const newQty = parseInt(btn.getAttribute('data-new-qty'), 10);
          updateCartItemQuantity(key, newQty);
        });
      });
    })
    .catch(err => console.error('Error fetching cart:', err));
}

function updateCartItemQuantity(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
  })
  .then(res => res.json())
  .then(() => {
    fetchCartAndUpdateDrawer();
  })
  .catch(err => console.error('Error updating cart:', err));
}

/* AJAX Quick Add to Cart */
function initAjaxCart() {
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(() => {
      if (window.YakshaTheme && window.YakshaTheme.openCartDrawer) {
        window.YakshaTheme.openCartDrawer();
      }
    })
    .catch(err => console.error('Error adding to cart:', err));
  });
}

/* Accordion Component */
function initAccordions() {
  const triggers = document.querySelectorAll('[data-accordion-trigger]');
  triggers.forEach(trigger => {
    if (trigger._accordionInitialized) return;
    trigger._accordionInitialized = true;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const content = trigger.nextElementSibling;
      if (!content) return;

      const isOpen = content.classList.contains('is-open');

      if (isOpen) {
        content.classList.remove('is-open');
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        content.classList.add('is-open');
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* Universal Zero-Bounce HD Product Image Crossfade */
function swapMainProductImage(newSrc, newAlt) {
  const mainImg = document.getElementById('main-product-img');
  const overlayImg = document.getElementById('main-product-img-overlay');
  if (!mainImg || !newSrc || !newSrc.trim()) return;

  const currentSrc = mainImg.getAttribute('src');
  if (currentSrc && (currentSrc === newSrc || currentSrc.includes(newSrc) || newSrc.includes(currentSrc))) {
    return; // Already on this image
  }

  if (overlayImg) {
    const tempImg = new Image();
    tempImg.src = newSrc;

    const executeCrossfade = () => {
      overlayImg.src = newSrc;
      if (newAlt) overlayImg.alt = newAlt;
      overlayImg.style.transition = 'opacity 0.35s ease';
      overlayImg.style.opacity = '1';

      setTimeout(() => {
        mainImg.src = newSrc;
        if (newAlt) mainImg.alt = newAlt;
        overlayImg.style.transition = 'none';
        overlayImg.style.opacity = '0';
        void overlayImg.offsetHeight; // Force reflow
        overlayImg.style.transition = '';
      }, 360);
    };

    if (tempImg.complete) {
      executeCrossfade();
    } else {
      tempImg.onload = executeCrossfade;
    }
  } else {
    mainImg.src = newSrc;
    if (newAlt) mainImg.alt = newAlt;
  }
}

/* Variant Selector Tabs & Gallery Thumbnails */
function initVariantTabs() {
  const variantTabs = document.querySelectorAll('[data-variant-tab]');
  const priceDisplay = document.getElementById('product-price-display');
  const titleHeading = document.getElementById('product-title-heading');
  const thumbButtons = document.querySelectorAll('.product-thumbnails button, [data-thumbnail-btn]');

  // 1. Thumbnail clicks: Always load crystal-clear 1400px HD image with zero bounce
  thumbButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      thumbButtons.forEach(b => b.classList.remove('is-active-thumb'));
      btn.classList.add('is-active-thumb');

      const fullSrc = btn.getAttribute('data-full-src');
      const img = btn.querySelector('img');
      const alt = img ? img.getAttribute('alt') : '';
      if (fullSrc) {
        swapMainProductImage(fullSrc, alt);
      }
    });
  });

  // 2. Variant tabs clicks
  variantTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const variantId = tab.getAttribute('data-variant-id');
      const variantImg = tab.getAttribute('data-variant-image');
      const variantPrice = tab.getAttribute('data-variant-price');
      const variantHeading = tab.getAttribute('data-variant-heading');
      const form = tab.closest('form');
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      if (idInput && variantId) idInput.value = variantId;

      const group = tab.closest('[data-variant-tabs]');
      if (group) {
        group.querySelectorAll('[data-variant-tab]').forEach(t => t.classList.remove('is-active'));
      }
      tab.classList.add('is-active');

      // Swap Main Product Image (Zero bounce, crystal-clear)
      if (variantImg && variantImg.trim() !== '') {
        swapMainProductImage(variantImg, variantHeading);

        // Sync matching thumbnail if present
        thumbButtons.forEach(b => {
          const bSrc = b.getAttribute('data-full-src') || '';
          if (bSrc && (bSrc.includes(variantImg) || variantImg.includes(bSrc))) {
            thumbButtons.forEach(x => x.classList.remove('is-active-thumb'));
            b.classList.add('is-active-thumb');
          }
        });
      }

      // Update Live Price
      if (priceDisplay && variantPrice) {
        priceDisplay.textContent = variantPrice;
      }

      // Update Title Heading
      if (titleHeading && variantHeading) {
        titleHeading.textContent = variantHeading;
      }

      // Update Key Specification Badges (Burn Time, Quantity)
      const burnTimeEl = document.querySelector('[data-spec-burn-time]');
      const quantityEl = document.querySelector('[data-spec-quantity]');
      const variantBurnTime = tab.getAttribute('data-variant-burn-time');
      const variantQuantity = tab.getAttribute('data-variant-quantity');

      if (burnTimeEl && variantBurnTime) {
        burnTimeEl.textContent = variantBurnTime;
      }
      if (quantityEl && variantQuantity) {
        quantityEl.textContent = variantQuantity;
      }
    });
  });
}

/* Infallible Persistent Sticky Navbar Engine */
function initStickyNavbar() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const headerSection = document.getElementById('shopify-section-header') || header.closest('.shopify-section') || header.parentElement;
  const announcementBar = document.getElementById('shopify-section-announcement-bar');

  function syncHeaderHeight() {
    if (headerSection) {
      headerSection.style.minHeight = header.offsetHeight + 'px';
    }
  }

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight, { passive: true });

  function handleScroll() {
    const announceHeight = announcementBar ? announcementBar.offsetHeight : 0;
    if (window.scrollY >= announceHeight && window.scrollY > 5) {
      header.classList.add('is-fixed-nav');
    } else {
      header.classList.remove('is-fixed-nav');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* Product Card Variant Hover Swap (Dhoop -> Incense -> Cone) */
function initCardVariantHover() {
  const cards = document.querySelectorAll('[data-aromatic-card], .product-card');

  cards.forEach(card => {
    const slideshow = card.querySelector('[data-variant-rotator]');
    if (!slideshow) return;

    const slides = Array.from(slideshow.querySelectorAll('[data-variant-form]'));
    if (slides.length <= 1) return;

    const pills = Array.from(card.querySelectorAll('[data-pill-form]'));
    const idInput = card.querySelector('input[name="id"]');
    let currentIndex = 0;
    let cycleInterval = null;
    let isUserLocked = false;

    function showVariant(index) {
      if (index < 0 || index >= slides.length) return;
      currentIndex = index;

      slides.forEach((s, idx) => {
        if (idx === index) {
          s.classList.add('active');
        } else {
          s.classList.remove('active');
        }
      });

      pills.forEach((p, idx) => {
        if (idx === index) {
          p.classList.add('active');
        } else {
          p.classList.remove('active');
        }
      });

      const activeSlide = slides[index];
      if (activeSlide && idInput) {
        const vId = activeSlide.getAttribute('data-variant-id');
        if (vId) idInput.value = vId;
      }
    }

    function startCycle() {
      if (cycleInterval) clearInterval(cycleInterval);
      isUserLocked = false;
      cycleInterval = setInterval(() => {
        if (isUserLocked) return;
        const nextIndex = (currentIndex + 1) % slides.length;
        showVariant(nextIndex);
      }, 1300);
    }

    function stopCycle() {
      if (cycleInterval) {
        clearInterval(cycleInterval);
        cycleInterval = null;
      }
      isUserLocked = false;
      showVariant(0); // Reset smoothly back to initial variant (Dhoop)
    }

    // Card hover cycles variants
    card.addEventListener('mouseenter', () => {
      startCycle();
    });

    card.addEventListener('mouseleave', () => {
      stopCycle();
    });

    // Horizontal mouse scrubbing across the image
    slideshow.addEventListener('mousemove', (e) => {
      isUserLocked = true;
      const rect = slideshow.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const ratio = Math.max(0, Math.min(0.999, x / rect.width));
      const targetIndex = Math.min(slides.length - 1, Math.floor(ratio * slides.length));
      if (targetIndex !== currentIndex) {
        showVariant(targetIndex);
      }
    });

    // Interactive variant pill hover and click
    pills.forEach((pill, pIndex) => {
      pill.addEventListener('mouseenter', (e) => {
        e.stopPropagation();
        isUserLocked = true;
        showVariant(pIndex);
      });

      pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        isUserLocked = true;
        showVariant(pIndex);
      });
    });
  });
}


